import { inject, InjectionToken } from '@angular/core';
import { LoadingService } from '../services';
import { from, Observable, of } from 'rxjs';
import { LoadingOptions } from '@ionic/angular';

export const LOADING_TOKEN: InjectionToken<LoadingProvider> = new InjectionToken<LoadingProvider>('LOADING_TOKEN', {
  factory: (): LoadingProvider => {
    const loadingService: LoadingService = inject(LoadingService);

    return {
      showLoading$(opts?: LoadingOptions): Observable<void> {
        return from(loadingService.showLoading(opts));
      },
      showLoading(opts?: LoadingOptions): void {
        loadingService.showLoading(opts);
      },
      dismissLoading$(): Observable<void> {
        loadingService.dismissLoading();
        return of(void 0);
      },
      dismissLoading(): void {
        loadingService.dismissLoading();
      },
      dismissAllLoadings$(): Observable<void> {
        return from(loadingService.dismissAllLoadings());
      },
      dismissAllLoadings(): void {
        loadingService.dismissAllLoadings();
      }
    };
  }
});

export interface LoadingProvider {
  showLoading$(opts?: LoadingOptions): Observable<void>;
  showLoading(opts?: LoadingOptions): void;
  dismissLoading$(): Observable<void>;
  dismissLoading(): void;
  dismissAllLoadings$(): Observable<void>;
  dismissAllLoadings(): void;
}
